import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "../assets/css/Home.css";
import "../assets/css/LegalPages.css";

const BrandMark = () => (
    <svg viewBox="0 0 512 512" aria-hidden="true" focusable="false">
        <path
            fill="currentColor"
            d="M448 256a192 192 0 1 0-384 0 192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-32 144a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        />
    </svg>
);

function PublicLegalLayout({ title, lastUpdated, description, children }) {
    const { user } = useAuth();
    const accountLink = user ? "/club" : "/login";
    const accountLabel = user ? "Dashboard" : "Log in";

    return (
        <div className="home-marketing legal-page">
            <header className="home-header legal-page-header">
                <div className="home-container home-header-inner legal-page-header-inner">
                    <Link to="/" className="home-brand" aria-label="CueClub Manager home">
                        <span className="home-brand-mark"><BrandMark /></span>
                        <span className="home-brand-text">CueClub Manager</span>
                    </Link>

                    <nav className="home-navigation legal-page-navigation" aria-label="Main navigation">
                        <Link to="/">Home</Link>
                        <Link to="/pricing">Pricing</Link>
                        <Link to={accountLink} className="home-nav-login">{accountLabel}</Link>
                    </nav>
                </div>
            </header>

            <main className="legal-page-main">
                <section className="legal-page-hero" aria-labelledby="legal-page-title">
                    <div className="home-container legal-page-hero-inner">
                        <p className="home-section-kicker">CueClub Manager legal</p>
                        <h1 id="legal-page-title">{title}</h1>
                        <p>{description}</p>
                        <span>Last updated: {lastUpdated}</span>
                    </div>
                </section>

                <div className="home-container legal-page-content">
                    {children}
                </div>
            </main>

            <footer className="home-footer legal-page-footer">
                <div className="home-container home-footer-inner">
                    <Link to="/" className="home-brand home-brand-footer" aria-label="CueClub Manager home">
                        <span className="home-brand-mark"><BrandMark /></span>
                        <span className="home-brand-text">CueClub Manager</span>
                    </Link>
                    <p>Built to keep cue-sport clubs in play.</p>
                    <nav aria-label="Legal">
                        <Link to="/privacy-policy">Privacy</Link>
                        <Link to="/general-conditions">General conditions</Link>
                        <Link to={accountLink}>{accountLabel}</Link>
                    </nav>
                    <small>© {new Date().getFullYear()} CueClub Manager</small>
                </div>
            </footer>
        </div>
    );
}

export default PublicLegalLayout;
